module.exports = __webpack_public_path__ + "static/media/yuce008.c0180546.png";